import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./static/css/common.css"
import './util/rem'
import ElementUI from 'element-ui';
import BaiduMap from 'vue-baidu-map'
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: 'VX8srP4mLw0EuaFuxcuG2EZNaSbGHz8z'
  //ak: 'uy7kvMNmLA6gjZH8z4pkXQx4MayQOG4g'
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
